import isArray from "../IsArray";

const getMetaFallbackErrorMessage = (queryOrMutation: unknown): string | undefined => {
	if (!queryOrMutation || typeof queryOrMutation !== "object") {
		return undefined;
	}
	const meta =
		(queryOrMutation as { meta?: { errorMessage?: unknown } }).meta?.errorMessage ??
		(queryOrMutation as { options?: { meta?: { errorMessage?: unknown } } }).options?.meta?.errorMessage;
	if (meta === undefined) {
		return undefined;
	}
	if (typeof meta === "object") {
		return JSON.stringify(meta);
	}
	return String(meta);
};

// format error message for all Tanstack query errors
export const formatErrorMessage = (error: any, queryOrMutation: unknown) => {
	let messages: string[] = ["Something went wrong. Please try again later."];
	// webserver error
	if (isArray(error?.data?.errors) && error?.data?.errors.length > 0) {
		messages = error.data.errors;
		// webserver error
	} else if (error?.data?.error) {
		messages = [error.data.error];
		//webserver error where we return errors but its only a string, not an array
	} else if (typeof error?.data?.errors === "string" && error?.data?.errors.length > 0) {
		messages = [error?.data?.errors];
		//internal api error
	} else if (error?.data?.message) {
		messages = [error.data.message];
		//generic error
	} else if (error?.message) {
		messages = [error.message];
	} else {
		const metaFallback = getMetaFallbackErrorMessage(queryOrMutation);
		if (metaFallback !== undefined) {
			messages = [metaFallback];
		}
	}

	// add this block to handle non-JSON errors
	if (error instanceof SyntaxError) {
		messages = ["Unknown error encountered. Please contact our support team for further information."];
	}

	return messages;
};
